import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchEvents } from "../api/fetchEvents";
import MeetupLinks from "../Components/PromoMaterials/MeetupLinks";
import "../styles/pages/promoListPage.scss";

const getBgColor = (color) => {
  const colorMap = {
    "ixda-red": "var(--ixda-red)",
    "ixda-purple": "var(--ixda-purple)",
    "ixda-blue": "var(--ixda-blue)",
    "ixda-green": "var(--ixda-green)",
    "ixda-orange": "var(--ixda-orange)",
    "ixda-pink": "var(--ixda-pink)",
    "ixda-cyan": "var(--ixda-cyan)",
    "ixda-yellow": "var(--ixda-yellow)",
    "gray-1": "var(--gray-1)",
    white: "var(--white)",
  };
  return colorMap[color] || "var(--ixda-yellow)";
};

const getTextColor = (color) => {
  if (["ixda-red", "ixda-purple", "gray-1"].includes(color)) {
    return "#ffffff";
  }
  return "#333333";
};

export const PromoListPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    html.style.overflow = "auto";
    html.style.position = "static";
    html.style.height = "auto";
    body.style.overflow = "auto";
    body.style.position = "static";
    body.style.height = "auto";
    body.style.overscrollBehaviorY = "auto";
    if (root) {
      root.style.overflow = "auto";
      root.style.position = "static";
      root.style.height = "auto";
    }

    return () => {
      html.style.overflow = "";
      html.style.position = "";
      html.style.height = "";
      body.style.overflow = "";
      body.style.position = "";
      body.style.height = "";
      body.style.overscrollBehaviorY = "";
      if (root) {
        root.style.overflow = "";
        root.style.position = "";
        root.style.height = "";
      }
    };
  }, []);

  useEffect(() => {
    const load = async () => {
      const data = await fetchEvents();
      const sorted = [...data].sort(
        (a, b) => (b.eventMeetupNo || 0) - (a.eventMeetupNo || 0)
      );
      setEvents(sorted);
      setLoading(false);
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="promo-list-page">
        <div className="promo-list-loading">Loading meetups...</div>
      </div>
    );
  }

  return (
    <div className="promo-list-page">
      <h1 className="promo-list-title">Promo material</h1>
      <div className="promo-list-layout">
        <div className="promo-list">
          {events.map((event) => (
            <Link
              key={event.eventMeetupNo}
              to={`/promo/${event.eventMeetupNo}`}
              className="promo-list-item"
              style={{
                backgroundColor: getBgColor(event.color),
                color: getTextColor(event.color),
              }}
            >
              <span className="promo-list-item-label">
                Meetup #{event.eventMeetupNo}
              </span>
              <span className="promo-list-item-arrow">{"\u2192"}</span>
            </Link>
          ))}
        </div>
        <MeetupLinks />
      </div>
    </div>
  );
};
